module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "imeceLogo.b0b331fc.png";